import { pl } from '@formkit/i18n'
import { defaultConfig } from '@formkit/vue'
import postal from './validationPostal.js'
import phone from './validationPhone.js'
import asci from './validationAsci.js'

export default defaultConfig({
  locales: { pl },
  locale: 'pl',
  rules: { postal, phone, asci }
})
